import React, { forwardRef } from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onAnimationStart' | 'onDragStart' | 'onDragEnd' | 'onDrag'> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  variant = 'primary',
  size = 'md',
  className = '',
  children,
  ...props
}, ref) => {
  const baseStyles = 'inline-flex items-center justify-center font-medium rounded-full transition-all focus:outline-none focus:ring-2 focus:ring-leaf focus:ring-offset-2 focus:ring-offset-surface disabled:opacity-50 disabled:pointer-events-none relative overflow-hidden';
  const variants = {
    primary: 'bg-leaf text-white hover:bg-[#319548] shadow-leaf-glow',
    secondary: 'bg-primary text-white hover:bg-[#0a2f23] shadow-glossy',
    outline: 'border-2 border-primary text-primary hover:bg-primary hover:text-white',
    ghost: 'text-primary hover:bg-primary/5'
  };
  const sizes = {
    sm: 'text-sm px-5 py-2',
    md: 'text-base px-6 py-3',
    lg: 'text-base px-8 py-4'
  };
  return <motion.button ref={ref} whileHover={{
    y: -2
  }} whileTap={{
    y: 0
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-81">
        {/* Glossy sheen overlay for filled variants */}
        {(variant === 'primary' || variant === 'secondary') && <span className="absolute inset-x-0 top-0 h-1/2 bg-gradient-to-b from-white/20 to-transparent pointer-events-none" data-id="element-82" />}
        <span className="relative" data-id="element-83">{children}</span>
      </motion.button>;
});
Button.displayName = 'Button';